<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <h4 qid="data-object-page-title" class="mb-1">
      <span v-if="isGranted(permissions.RISK_CATEGORY_CREATE)"
            class="btn btn-success float-right"
            qid="create-rc-button"
            @click="showCreateRCModal()"
      >
        <font-awesome-icon icon="plus-circle"/> {{ $t('maintenance.risk_categories.create_button') }}
      </span>
      <b-form-input
          type="text"
          v-model="filters.keywordValue"
          class="float-right mw-300 mr-3 search-bar"
          v-on:input="debounceInput"
          :placeholder="$t('maintenance.risk_categories.search_placeholder')"
          qid="search-rc-input"
      ></b-form-input>
      {{ $t('maintenance.risk_categories.title') }}
    </h4>
    <div>
      <span v-if="getGuide('risk_categories_list')">
        <GuideButton :guide="getGuide('risk_categories_list')"></GuideButton>
      </span>
    </div>
    <!-- <div class="row mb-3">
      <div class="col-sm-4">
        <h4 qid="risk_categories-page-title" class="mb-2">
          {{ $t('maintenance.risk_categories.title') }}
        </h4>
        <div>
          <span v-if="getGuide('risk_categories_list')">
            <GuideButton :guide="getGuide('risk_categories_list')"></GuideButton>
          </span>
        </div>
      </div>
      <div class="col-sm-8 text-right">
        <router-link
            to="/maintenance/risk-categories/create"
            class="btn btn-success float-right"
            qid="create-rc-button"
            v-if="isGranted(permissions.RISK_CATEGORY_CREATE)"
        >
          <font-awesome-icon icon="plus-circle"/> {{ $t('maintenance.risk_categories.create_button') }}
        </router-link>
        <b-form-input
          type="text"
          v-model="filters.keywordValue"
          class="float-right mw-300 mr-3 search-bar"
          qid="search-rc-input"
          v-on:input="debounceInput"
          :placeholder="$t('maintenance.risk_categories.search_placeholder')"
        ></b-form-input>
      </div>
    </div> -->

    <div class="row mt-4" :class="{'table-with-filters': filterOpened}">
      <div class="col-sm-10 table-container">
        <div class="">
          <table class="table table-responsive-md table-list">
            <thead>
              <tr>
                <th scope="col"
                    class="cursor-pointer"
                    @click="selectSort('name')"
                    qid="sort-rc-name"
                >
                  {{ $t('maintenance.risk_categories.table.name') }}
                  <span class="ml-2">
                    <font-awesome-icon class="text-muted" icon="sort" v-if="selectedSort !== 'name'"/>
                    <font-awesome-icon icon="caret-down" v-if="selectedDirection === 'desc' && selectedSort === 'name'"/>
                    <font-awesome-icon icon="caret-up" v-if="selectedDirection === 'asc' && selectedSort === 'name'"/>
                  </span>
                </th>
                <th scope="col" class="text-center">
                  {{ $t('maintenance.risk_categories.table.business_risk_tolerance') }}
                </th>
                <th scope="col" class="text-center">
                  {{ $t('maintenance.risk_categories.table.privacy_risk_tolerance') }}
                </th>
                <th scope="col" class="text-center">
                  {{ $t('risk.business_risk_criteria') }}
                </th>
                <th scope="col" class="text-center">
                  {{ $t('risk.privacy_risk_criteria') }}
                </th>
                <th scope="col" class="text-center">
                  {{ $t('risk.linked_risks') }}
                </th>
                <th scope="col"
                    class="cursor-pointer"
                    @click="selectSort('updated_at')"
                    qid="sort-s-name"
                >
                  {{ $t('system.last_updated') }}
                  <span class="ml-2">
                    <font-awesome-icon class="text-muted" icon="sort" v-if="selectedSort !== 'updated_at'"/>
                    <font-awesome-icon icon="caret-down" v-if="selectedDirection === 'desc' && selectedSort === 'updated_at'"/>
                    <font-awesome-icon icon="caret-up" v-if="selectedDirection === 'asc' && selectedSort === 'updated_at'"/>
                  </span>
                </th>
                <th width="130"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(object, index) in tableItems" :key="'table-row-' + index" :id="'table-row-' + index">
                <b-popover
                    :target="'table-row-' + index"
                    boundary="viewport"
                    triggers="hover"
                    placement="topleft"
                    :delay="{ show: 500, hide: 0 }"
                >

                  <div v-if="object.description" class="mt-2">
                    <span class="text-bold">
                      {{ $t('maintenance.risk_categories.create.description_label') }}:
                    </span>
                    <br>
                    {{ object.description | truncate(200)}}
                    <br>
                  </div>

                  <div v-if="object.business_risk_tolerance_impact || object.business_risk_tolerance_description" class="mt-2">
                    <span class="text-bold">
                      {{ $t('maintenance.risk_categories.table.business_risk_tolerance') }}:
                    </span>
                    <div v-if="object.business_risk_tolerance_impact" class="mt-2">
                      <span class="text-bold">
                        {{ $t('maintenance.risk_categories.risk.impact_label') }}:
                      </span>
                      <br>
                        <font-awesome-icon icon="exclamation-triangle" class="risk-1 mr-2" v-if="object.business_risk_tolerance_impact == 'Very low'"/>
                        <font-awesome-icon icon="exclamation-triangle" class="risk-1 mr-2" v-if="object.business_risk_tolerance_impact == 'Low'"/>
                        <font-awesome-icon icon="exclamation-triangle" class="risk-9 mr-2" v-if="object.business_risk_tolerance_impact == 'High'"/>
                        <font-awesome-icon icon="exclamation-triangle" class="risk-16 mr-2" v-if="object.business_risk_tolerance_impact == 'Very high'"/>
                      {{ object.business_risk_tolerance_impact }}
                      <br>
                    </div>
                    <div v-if="object.business_risk_tolerance_probability" class="mt-2">
                      <span class="text-bold">
                        {{ $t('maintenance.risk_categories.risk.probability_label') }}:
                      </span>
                      <br>
                        <font-awesome-icon icon="exclamation-triangle" class="risk-1 mr-2" v-if="object.business_risk_tolerance_probability == 'Very unlikely'"/>
                        <font-awesome-icon icon="exclamation-triangle" class="risk-1 mr-2" v-if="object.business_risk_tolerance_probability == 'Unlikely'"/>
                        <font-awesome-icon icon="exclamation-triangle" class="risk-9 mr-2" v-if="object.business_risk_tolerance_probability == 'Likely'"/>
                        <font-awesome-icon icon="exclamation-triangle" class="risk-16 mr-2" v-if="object.business_risk_tolerance_probability == 'Very likely'"/>
                      {{ object.business_risk_tolerance_probability }}
                      <br>
                    </div>
                    <div v-if="object.business_risk_tolerance_description" class="mt-2">
                      <span class="text-bold">
                        {{ $t('maintenance.risk_categories.risk.description_label') }}:
                      </span>
                      <br>
                      {{ object.business_risk_tolerance_description | truncate(200)}}
                      <br>
                    </div>
                  </div>

                  <div v-if="object.privacy_risk_tolerance_impact || object.privacy_risk_tolerance_description" class="mt-2">
                    <span class="text-bold">
                      {{ $t('maintenance.risk_categories.table.privacy_risk_tolerance') }}:
                    </span>
                    <div v-if="object.privacy_risk_tolerance_impact" class="mt-2">
                      <span class="text-bold">
                        {{ $t('maintenance.risk_categories.risk.impact_label') }}:
                      </span>
                      <br>
                        <font-awesome-icon icon="exclamation-triangle" class="risk-1 mr-2" v-if="object.privacy_risk_tolerance_impact == 'Very low'"/>
                        <font-awesome-icon icon="exclamation-triangle" class="risk-1 mr-2" v-if="object.privacy_risk_tolerance_impact == 'Low'"/>
                        <font-awesome-icon icon="exclamation-triangle" class="risk-9 mr-2" v-if="object.privacy_risk_tolerance_impact == 'High'"/>
                        <font-awesome-icon icon="exclamation-triangle" class="risk-16 mr-2" v-if="object.privacy_risk_tolerance_impact == 'Very high'"/>
                      {{ object.privacy_risk_tolerance_impact }}
                      <br>
                    </div>
                    <div v-if="object.privacy_risk_tolerance_probability" class="mt-2">
                      <span class="text-bold">
                        {{ $t('maintenance.risk_categories.risk.probability_label') }}:
                      </span>
                      <br>
                        <font-awesome-icon icon="exclamation-triangle" class="risk-1 mr-2" v-if="object.privacy_risk_tolerance_probability == 'Very unlikely'"/>
                        <font-awesome-icon icon="exclamation-triangle" class="risk-1 mr-2" v-if="object.privacy_risk_tolerance_probability == 'Unlikely'"/>
                        <font-awesome-icon icon="exclamation-triangle" class="risk-9 mr-2" v-if="object.privacy_risk_tolerance_probability == 'Likely'"/>
                        <font-awesome-icon icon="exclamation-triangle" class="risk-16 mr-2" v-if="object.privacy_risk_tolerance_probability == 'Very likely'"/>
                      {{ object.privacy_risk_tolerance_probability }}
                      <br>
                    </div>
                    <div v-if="object.privacy_risk_tolerance_description" class="mt-2">
                      <span class="text-bold">
                        {{ $t('maintenance.risk_categories.risk.description_label') }}:
                      </span>
                      <br>
                      {{ object.privacy_risk_tolerance_description | truncate(200)}}
                      <br>
                    </div>
                  </div>
                </b-popover>

                <td>
                  <router-link
                      :to="{ name: 'maintenance.risk_categories.view', params: { slug: object.slug }}"
                      qid="v-view-page-link"
                  >
                    {{ object.name }}
                  </router-link>
                </td>
                <td class="text-center">
                  <div v-if="getClient.risk_type != 'cia_risk'">
                    <span class="badge-pill badge-success mr-1"
                          v-if="object.business_risk_tolerance && object.business_risk_tolerance.number"
                    >
                      <font-awesome-icon icon="check" size="xs"/>
                    </span>
                    <span class="badge-pill badge-danger mr-1" v-else>
                      <font-awesome-icon icon="times" size="xs"/>
                    </span>
                  </div>
                  <div v-if="getClient.risk_type == 'cia_risk'">
                    <span class="badge-pill badge-success mr-1"
                          v-if="
                            object.business_risk_confidentiality &&
                            object.business_risk_confidentiality.number &&
                            object.business_risk_integrity &&
                            object.business_risk_integrity.number &&
                            object.business_risk_availability &&
                            object.business_risk_availability.number
                          "
                    >
                      <font-awesome-icon icon="check" size="xs"/>
                    </span>
                    <span class="badge-pill badge-danger mr-1" v-else>
                      <font-awesome-icon icon="times" size="xs"/>
                    </span>
                  </div>
                </td>
                <td class="text-center">
                  <div v-if="getClient.risk_type != 'cia_risk'">
                    <span class="badge-pill badge-success mr-1"
                          v-if="object.privacy_risk_tolerance && object.privacy_risk_tolerance.number"
                    >
                      <font-awesome-icon icon="check" size="xs"/>
                    </span>
                    <span class="badge-pill badge-danger mr-1" v-else>
                      <font-awesome-icon icon="times" size="xs"/>
                    </span>
                  </div>
                  <div v-if="getClient.risk_type == 'cia_risk'">
                    <span class="badge-pill badge-success mr-1"
                          v-if="
                            object.privacy_risk_confidentiality &&
                            object.privacy_risk_confidentiality.number &&
                            object.privacy_risk_integrity &&
                            object.privacy_risk_integrity.number &&
                            object.privacy_risk_availability &&
                            object.privacy_risk_availability.number
                          "
                    >
                      <font-awesome-icon icon="check" size="xs"/>
                    </span>
                    <span class="badge-pill badge-danger mr-1" v-else>
                      <font-awesome-icon icon="times" size="xs"/>
                    </span>
                  </div>
                </td>
                <td class="text-center">
                  <div v-if="getClient.risk_type == 'cia_risk'">
                    <span class="badge-pill badge-success mr-1"
                          v-if="
                            object.business_risk_confidentiality_impact_very_low_definition &&
                            object.business_risk_confidentiality_impact_low_definition &&
                            object.business_risk_confidentiality_impact_high_definition &&
                            object.business_risk_confidentiality_impact_very_high_definition &&

                            object.business_risk_integrity_impact_very_low_definition &&
                            object.business_risk_integrity_impact_low_definition &&
                            object.business_risk_integrity_impact_high_definition &&
                            object.business_risk_integrity_impact_very_high_definition &&

                            object.business_risk_availability_impact_very_low_definition &&
                            object.business_risk_availability_impact_low_definition &&
                            object.business_risk_availability_impact_high_definition &&
                            object.business_risk_availability_impact_very_high_definition &&

                            object.business_risk_probability_very_unlikely_definition &&
                            object.business_risk_probability_unlikely_definition &&
                            object.business_risk_probability_likely_definition &&
                            object.business_risk_probability_very_likely_definition
                          "
                    >
                      <font-awesome-icon icon="check" size="xs"/>
                    </span>
                    <span class="badge-pill badge-danger mr-1" v-else>
                      <font-awesome-icon icon="times" size="xs"/>
                    </span>
                  </div>
                  <div v-if="getClient.risk_type != 'cia_risk'">
                    <span class="badge-pill badge-success mr-1"
                          v-if="
                            object.business_risk_impact_very_low_definition &&
                            object.business_risk_impact_low_definition &&
                            object.business_risk_impact_high_definition &&
                            object.business_risk_impact_very_high_definition &&
                            object.business_risk_probability_very_unlikely_definition &&
                            object.business_risk_probability_unlikely_definition &&
                            object.business_risk_probability_likely_definition &&
                            object.business_risk_probability_very_likely_definition
                          "
                    >
                      <font-awesome-icon icon="check" size="xs"/>
                    </span>
                    <span class="badge-pill badge-danger mr-1" v-else>
                      <font-awesome-icon icon="times" size="xs"/>
                    </span>
                  </div>
                </td>
                <td class="text-center">
                  <div v-if="getClient.risk_type == 'cia_risk'">
                    <span class="badge-pill badge-success mr-1"
                          v-if="
                            object.privacy_risk_confidentiality_impact_very_low_definition &&
                            object.privacy_risk_confidentiality_impact_low_definition &&
                            object.privacy_risk_confidentiality_impact_high_definition &&
                            object.privacy_risk_confidentiality_impact_very_high_definition &&

                            object.privacy_risk_integrity_impact_very_low_definition &&
                            object.privacy_risk_integrity_impact_low_definition &&
                            object.privacy_risk_integrity_impact_high_definition &&
                            object.privacy_risk_integrity_impact_very_high_definition &&

                            object.privacy_risk_availability_impact_very_low_definition &&
                            object.privacy_risk_availability_impact_low_definition &&
                            object.privacy_risk_availability_impact_high_definition &&
                            object.privacy_risk_availability_impact_very_high_definition &&

                            object.privacy_risk_probability_very_unlikely_definition &&
                            object.privacy_risk_probability_unlikely_definition &&
                            object.privacy_risk_probability_likely_definition &&
                            object.privacy_risk_probability_very_likely_definition
                          "
                    >
                      <font-awesome-icon icon="check" size="xs"/>
                    </span>
                    <span class="badge-pill badge-danger mr-1" v-else>
                      <font-awesome-icon icon="times" size="xs"/>
                    </span>
                  </div>
                  <div v-if="getClient.risk_type != 'cia_risk'">
                    <span class="badge-pill badge-success mr-1"
                          v-if="
                            object.privacy_risk_impact_very_low_definition &&
                            object.privacy_risk_impact_low_definition &&
                            object.privacy_risk_impact_high_definition &&
                            object.privacy_risk_impact_very_high_definition &&
                            object.privacy_risk_probability_very_unlikely_definition &&
                            object.privacy_risk_probability_unlikely_definition &&
                            object.privacy_risk_probability_likely_definition &&
                            object.privacy_risk_probability_very_likely_definition
                          "
                    >
                      <font-awesome-icon icon="check" size="xs"/>
                    </span>
                    <span class="badge-pill badge-danger mr-1" v-else>
                      <font-awesome-icon icon="times" size="xs"/>
                    </span>
                  </div>
                </td>
                <td class="text-center">
                  {{ object.linked_risks }}
                </td>
                <td>
                  <span>
                    <Avatar :object="object.updated_by" size="xs" class="mr-2" v-if="object.updated_by"></Avatar>
                    {{ object.updated_at | formatDate }}
                  </span>
                </td>
                <td>
                  <span v-if="isGranted([permissions.RISK_CATEGORY_EDIT, permissions.RISK_CATEGORY_EDIT_OWN], object.created_by) && (!getClient.parent || (getClient.parent && object.partition))"
                        class="btn btn-edit"
                        qid="edit-rc-modal"
                        @click="showEditRCModal(object)"
                  >
                    <font-awesome-icon icon="pen"/>
                  </span>
                  <span v-if="isGranted([permissions.RISK_CATEGORY_DELETE, permissions.RISK_CATEGORY_DELETE_OWN], object.created_by) && (!getClient.parent || (getClient.parent && object.partition))"
                        class="btn btn-delete"
                        qid="delete-rc-modal"
                        @click="showConfirmDeleteModal(object)"
                  >
                    <font-awesome-icon icon="trash-alt"/>
                  </span>
                </td>
              </tr>
              <tr v-if="!loading && !tableItems.length" qid="no-results-row" class="text-center">
                <td colspan="10">
                  <h5 class="mt-3">
                    {{ $t('system.no_results') }}
                  </h5>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="mt-3 pagination row">
          <div class="col-md-6">
            <div class="row">
              <div class="float-left">
                <span class="text-muted pagination-counter">
                  {{ $t('pagination.entries_per_page') }}:
                </span>
              </div>
              <div class="float-left">
                <multiselect
                    v-model="perPage"
                    :options="perPageOptions"
                    track-by="value"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    label="value"
                    qid="create-org-form-organization-level"
                    @select="perPageChanged"
                    :placeholder="selectedPerPage"
                    @remove="perPageRemoved"
                ></multiselect>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <b-pagination
                class="float-right"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="selectedPerPage"
                aria-controls="my-table"
                @change="pageChanged"
                limit="1"
            >
              <span class="text-muted" slot="first-text"><font-awesome-icon icon="angle-double-left"/></span>
              <span class="text-muted" slot="prev-text"><font-awesome-icon icon="angle-left"/></span>
              <span class="text-muted" slot="next-text"><font-awesome-icon icon="angle-right"/></span>
              <span class="text-muted" slot="last-text"><font-awesome-icon icon="angle-double-right"/></span>
              <div slot="ellipsis-text">
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
              </div>
              <span class="text-muted" slot="page" slot-scope="{ page, active }">
                <span v-if="active">{{getPerPage}}</span>
              </span>
            </b-pagination>
          </div>
        </div>
      </div>
    </div>


    <!-- Delete risk category confirm modal template -->
    <b-modal ref="delete-risk-category" modal-class="task-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideConfirmDeleteModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="delete-rc-title">
            {{ $t('maintenance.risk_categories.delete.title') }}
          </h5>
        </div>
      </template>
      <div class="mb-2 mt-3" style="font-size:18px;">
        <div>
          {{ $t('maintenance.risk_categories.delete.description') }}
          <span class="text-bold">
            {{ itemToDelete.name }}
          </span>
        </div>
        <div class="mt-2">
          {{ $t('maintenance.risk_categories.delete.are_you_sure') }}
        </div>
      </div>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideConfirmDeleteModal"
                            qid="delete-rc-cancel-button"
                  >
                    {{ $t('maintenance.risk_categories.delete.cancel') }}
                  </b-button>
                  <b-button @click="confirmDeleteRC(itemToDelete)"
                            class="ml-3"
                            variant="danger"
                            qid="delete-rc-submit-button"
                            v-if="isGranted([permissions.RISK_CATEGORY_DELETE, permissions.RISK_CATEGORY_DELETE_OWN], itemToDelete.created_by) && (!getClient.parent || (getClient.parent && itemToDelete.partition))"
                  >
                    {{ $t('maintenance.risk_categories.delete.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>


    <!-- Edit risk category modal template -->
    <b-modal ref="edit-risk-category" @hide="hideEditRCModal" modal-class="task-modal" hide-footer>
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideEditRCModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="update-rc-title">
            {{ $t('maintenance.risk_categories.update.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="edit-rc-error"
      >
        {{ error }}
      </b-alert>

      <b-form @submit="editRCFormSubmit" qid="edit-rc-form">
        <div class="form-container">
          <b-form-group>
            <label qid="edit-rc-name-label">
              {{ $t('maintenance.risk_categories.create.name_label') }}<span class="mandatory"> *</span>
            </label>
            <b-form-input
              qid="edit-rc-form-name"
              type="text"
              v-model="rcForm.name"
              :maxLength="255"
              required
              :placeholder="$t('maintenance.risk_categories.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="edit-rc-description-label">
              {{ $t('maintenance.risk_categories.create.description_label') }}
            </label>
            <b-form-textarea
              qid="edit-rc-form-description"
              v-model="rcForm.description"
              rows="6"
              max-rows="6"
              :placeholder="$t('maintenance.risk_categories.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
        </div>
        <div class="proxy-footer">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideEditRCModal"
                            qid="edit-rc-cancel-button"
                  >
                    {{ $t('maintenance.risk_categories.create.cancel') }}
                  </b-button>
                  <b-button type="submit"
                            class="ml-3"
                            variant="success"
                            :disabled="buttonDisabled"
                            qid="edit-rc-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.risk_categories.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </b-modal>


    <!-- Create risk category -->
    <b-modal ref="create-risk-category" @hide="hideCreateRCModal" modal-class="task-modal" hide-footer>
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideCreateRCModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="create-rc-title">
            {{ $t('maintenance.risk_categories.create.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-rc-error"
      >
        {{ error }}
      </b-alert>

      <b-form @submit="createRCFormSubmit" qid="create-rc-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-rc-name-label">
              {{ $t('maintenance.risk_categories.create.name_label') }}<span class="mandatory"> *</span>
            </label>
            <b-form-input
              qid="create-rc-form-name"
              type="text"
              v-model="rcForm.name"
              :maxLength="255"
              required
              :placeholder="$t('maintenance.risk_categories.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-rc-description-label">
              {{ $t('maintenance.risk_categories.create.description_label') }}
            </label>
            <b-form-textarea
              qid="create-rc-form-description"
              v-model="rcForm.description"
              rows="6"
              max-rows="6"
              :placeholder="$t('maintenance.risk_categories.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
        </div>
        <div class="proxy-footer">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideCreateRCModal"
                            qid="create-mc-cancel-button"
                  >
                    {{ $t('maintenance.risk_categories.create.cancel') }}
                  </b-button>
                  <b-button type="submit"
                            class="ml-3"
                            variant="success"
                            :disabled="buttonDisabled"
                            qid="create-rc-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.risk_categories.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js';
  import Avatar from '@/components/Avatar.vue';
  import GuideButton from '@/components/guide/GuideButton.vue';


  export default {
    name: 'RiskCategories',
    data: function() {
      return {
        breadcrumbItems: [
          {
            text: this.$t('dashboard.title'),
            to: '/'
          },
          {
            text: this.$t('maintenance.title'),
            to: '/maintenance'
          },
          {
            text: this.$t('maintenance.risk_categories.title'),
            active: true
          }
        ],
        tableItems: [],

        // Pagination
        perPageOptions: [
          { name: '10', value: '10' },
          { name: '20', value: '20' },
          { name: '50', value: '50' },
          { name: '100', value: '100' }
        ],
        perPage: '',
        selectedPerPage: "10",
        currentPage: 1,
        totalRows: 0,

        itemToDelete: {},
        rcForm: {
          name: '',
          description: '',
          client:'',
        },
        error: '',
        selectedSort: '',
        selectedDirection: '',
        filterOpened: false,
        keywordValue: '',
        filters: {
          time_limit: '',
          keywordValue: ''
        },
        timeLimitItems: [],
        timeLimitInput: '',
        loading: true,
        buttonDisabled: false,
        myGuides: [],
      }
    },
    computed: {
      rows() {
        // Use computed value for rows because of dynamic update
        return this.totalRows
      },
      getClient() {
        return this.$store.state.client
      },
      getFilters() {
        return this.$store.state.activeFilters
      },
      getStorePerPage() {
        return this.$store.state.perPage
      },
      getPerPage() {
        let page = this.currentPage;
        let selectedFrom = (page-1) * Number(this.selectedPerPage) + 1;
        let selectedTo = (page-1) * Number(this.selectedPerPage) + Number(this.selectedPerPage);
        let selectedOf = this.totalRows;

        if(selectedTo > selectedOf){
          selectedTo = selectedOf
        }

        return selectedFrom + " - " + selectedTo + " " + this.$t('system.of') + " " + selectedOf
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
        this.loadContent();
      }
    },
    methods: {
      debounceInput: _.debounce(function() {
        this.loadContent()
      }, 400),
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'Maintenance' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Maintenance',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
          }
        }, function() {});
      },
      resetFilters() {
        this.filters.time_limit = '',
        this.debounceInput()
      },
      selectSort(sort) {
        // If old and new sort are same, switch just direction
        if (sort === this.selectedSort) {
          this.selectedDirection = this.selectedDirection === 'desc' ? 'asc' : 'desc';
        } else {
          // If different sort, set sort and set direction to default
          this.selectedDirection = 'desc'
          this.selectedSort = sort;
        }
        this.loadContent();
      },
      loadContent(page, perPage) {

        if (this.getStorePerPage) {
          this.selectedPerPage = this.getStorePerPage;
        }

        // If page is not defined, set page to default 1
        let pageNumber = page ? page : 1;
        let perPageNumber = perPage ? perPage : this.selectedPerPage;
        let self = this;
        piincHttp.get('/risk-categories', { params:
          {
            page: pageNumber,
            per_page: perPageNumber,
            sort: this.selectedSort !== '' ? this.selectedSort : undefined,
            order: this.selectedDirection !== '' ? this.selectedDirection : undefined,
            keyword: this.filters.keywordValue !== '' ? this.filters.keywordValue : undefined,
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.loading = false;
          self.tableItems = response.data.items;
          // Set number of total items
          self.totalRows = response.data.total_count;
        }, function() {});
      },
      pageChanged(page) {
        this.loadContent(page)
      },
      perPageChanged(perPage) {
        let self = this;
        // Load content when page changed listener is triggered
        this.loadContent(1, perPage.value)
        self.selectedPerPage = perPage.value
        this.$store.commit('storePerPage', this.selectedPerPage);
      },
      perPageRemoved() {
        let self = this;
        // Load content when page changed listener is triggered
        self.selectedPerPage = self.perPageOptions[0].value
        this.loadContent(1, self.selectedPerPage)
      },
      showConfirmDeleteModal(object) {
        this.itemToDelete = object
        this.$refs['delete-risk-category'].show()
      },
      hideConfirmDeleteModal() {
        this.itemToDelete = {}
        this.$refs['delete-risk-category'].hide()
      },
      hideCreateRCModal() {
        this.rcForm.name = '';
        this.rcForm.description = '';
        this.$refs['create-risk-category'].hide()
      },
      showCreateRCModal(object) {
        let self = this;

        this.error = '';
        this.rcForm.name = '';
        this.rcForm.description = '';
        this.$refs['create-risk-category'].show()
      },
      createRCFormSubmit(evt) {
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();
        this.rcForm.client = this.getClient.slug;

        if (this.rcForm.name && this.rcForm.name.length) {
          this.buttonDisabled = true;
          piincHttp.post('risk-categories/', this.rcForm).then(function(response) {
            self.hideCreateRCModal();
            self.loadContent(self.currentPage);
            self.buttonDisabled = false;
            self.$toastr('success', self.$t('maintenance.risk_categories.create.success'))
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              // Attach error if exists
              self.error = ''
              if (error.data.errors.name) {
                self.error += ' ' + self.$t('maintenance.risk_categories.create.name_error')
              }else{
                self.error = error.data.message;
              }
            }
          })
        } else {
          this.error = ''

          if (this.rcForm.name == '' || this.rcForm.name == null) {
            this.error +=  ' ' + this.$t('system.name_error_message')
          }
        }


      },
      showEditRCModal(object) {
        let self = this;

        this.error = '';
        this.rcForm.slug = object.slug;
        this.rcForm.name = object.name;
        this.rcForm.description = object.description;
        this.$refs['edit-risk-category'].show()
      },
      hideEditRCModal() {
        this.timeLimitInput = ''
        this.$refs['edit-risk-category'].hide()
      },
      editRCFormSubmit(evt) {
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();
        this.rcForm.client = this.getClient.slug;

        if (this.rcForm.name && this.rcForm.name.length) {
          this.buttonDisabled = true;
          piincHttp.put('/risk-categories/' + this.rcForm.slug, this.rcForm).then(function(response) {
            self.hideEditRCModal();
            self.buttonDisabled = false;
            self.loadContent(self.currentPage);
            self.$toastr('success', self.$t('maintenance.risk_categories.update.success'))
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              // Attach error if exists
              self.error = ''
              if (error.data.errors.name) {
                self.error += ' ' + self.$t('maintenance.risk_categories.create.name_error')
              }else{
                self.error = error.data.message;
              }
            }
          })
        } else {
          this.error = ''

          if (!this.rcForm.name.length) {
            this.error +=  ' ' + this.$t('system.name_error_message')
          }
        }

      },
      confirmDeleteRC(object) {
        let self = this;
        piincHttp.delete('risk-categories/' + object.slug).then(function(response) {
          self.hideConfirmDeleteModal();
          self.loadContent(self.currentPage);
          // Trigger toastr message after modal close
          self.$toastr('success', self.$t('maintenance.risk_categories.delete.success'))
        }, function() {});
      }
    },
    components: {
      Avatar,
      GuideButton
    },
    beforeRouteLeave(to, from, next) {
      let object = {
        type: 'risk_categories',
        filters: this.filters
      }
      this.$store.commit('storeActiveFilters', object);
      this.$store.commit('storePerPage', this.selectedPerPage);
      next()
    },
    created () {
      if (this.getClient && this.getClient.slug) {
        if (this.getFilters.risk_categories) {
          this.filters = this.getFilters.risk_categories
        }
        this.loadContent();
      }
      this.loadGuides('risk_categories_list');
    }
  }
</script>
